// extracted by mini-css-extract-plugin
export default {"page-opacity":"styles_page-opacity__hFHlZ","page__full-screen":"styles_page__full-screen__L748o"};